<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import ToggleItem from '../common/ToggleItem.vue';
import { IconOutlineDarkMode } from '@iconify-prerendered/vue-ic';
import { useDarkMode } from 'shared/themes/composables/darkMode';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const darkMode = useDarkMode();
const { enabled } = storeToRefs(darkMode);

const description = computed(() =>
  darkMode.enabled
    ? translations.value.settings.general.dark
    : translations.value.settings.general.light,
);

function toggle(toggled: boolean) {
  darkMode.enabled = toggled;
}
</script>

<template>
  <ToggleItem
    :title="translations.settings.general.colorMode"
    :description="description"
    :toggled="enabled"
    @click="toggle"
  >
    <template #icon
      ><IconOutlineDarkMode style="width: 2rem; height: 2rem"></IconOutlineDarkMode
    ></template>
  </ToggleItem>
</template>
